export const HOST = Window['HOST'];
export const HOST_MOCK = Window['HOST_MOCK'];
export const HOST_LANGUAGE = 'https://apis.callmehuyv.com/language-management/invoice-management';

export const API = {
	// Session
	host: HOST,
	login: HOST + 'session/login',
	logout: HOST + 'session/logout',
	profile: HOST + 'session/profile',
}
